export default {
  btn: {
    addWorker: "ワーカー追加",
    save: "保存",
  },
  searchForm: {
    name: "氏名",
    workId: "業務名",
    search: "検索",
    btn: {
      back: "戻る",
      edit: "編集",
      cancel: "キャンセル",
      save: "保存",
    },
    hasPlanFlgValue: {
      valid: "有効",
      invalid: "無効",
    },
    callRequiredValue: {
      valid: "必要",
      invalid: "不要",
    },
    dataNull: "全て",
  },
  columns: {
    workerCode: "社員番号",
    fullNameKanji: "氏名（漢字）",
    fullNameKana: "氏名（カナ） ",
    address: "住所",
    personalEmail: "個人メールアドレス",
    cyberEmail: "サイバーメールアドレス",
    dialpadIssued: "Dialpad発行 ",
    contractStatus: "契約有効区分",
    contractStartDate: "直近の契約締結日",
    invoiceRegistration: "インボイス登録",
    accountNumber: "口座番号",
    accountName: "口座名義 ",
    workName: "支払通知書適応業務",
    memo: "メモ",
    action: "アクション",
  },
  status: {
    yes: "あり",
    no: "なし",
  },
  invoiceRegistration: {
    active: "登録済",
    inactive: "未登録",
  },
  workerNumber: {
    title: "管理番号",
    workerNumber: {
      label: "社員番号",
      placeholder: "社員番号を入力してください",
    },
  },
  nameInformation: {
    title: "氏名情報",
    lastNameKanji: {
      label: "姓（漢字）",
      placeholder: "姓（漢字）を入力してください",
    },
    firstNameKanji: {
      label: "名（漢字）",
      placeholder: "名（漢字）を入力してください",
    },
    lastNameKana: {
      label: "姓（カナ）",
      placeholder: "姓（カナ）を入力してください",
    },
    firstNameKana: {
      label: "名（カナ）",
      placeholder: "名（カナ）を入力してください",
    },
    fullNameKanji: {
      label: "氏名（漢字）",
    },
    fullNameKana: {
      label: "氏名（カナ）",
    },
  },
  addressInformation: {
    title: "住所情報",
    postalCode: {
      btnFill: "住所反映",
      label: "郵便番号",
      placeholder: "xxx-xxxx形式で入力してください",
    },
    prefecture: {
      label: "都道府県",
    },
    municipality: {
      label: "市区町村",
    },
    street: {
      label: "番地",
      placeholder: "番地を入力してください",
    },
    buildingRoom: {
      label: "建物・部屋番号",
      placeholder: "建物・部屋番号を入力してください",
    },
    address: {
      label: "住所",
    },
  },
  contactInformation: {
    title: "連絡情報",
    personalEmail: {
      label: "個人メールアドレス",
      placeholder: "個人メールアドレスを入力してください",
    },
    cyberEmail: {
      label: "サイバーメールアドレス",
      placeholder: "サイバーメールアドレスを入力してください",
    },
    dialpadIssued: {
      label: "Dialpad発行",
      valid: "あり",
      invalid: "なし",
    },
  },
  invoiceRegistrationInformation: {
    title: "インボイス情報",
    invoiceRegistration: {
      label: "インボイス登録",
      valid: "未登録",
      invalid: "登録済",
    },
    taxableBusinessNumber: {
      label: "課税事業者番号",
      placeholder: "課税事業者番号を入力してください",
    },
  },
  accountInformation: {
    title: "口座情報",
    accountType: {
      label: "口座区分",
      valid: "普通",
      invalid: "当座",
    },
    bankName: {
      label: "銀行名",
      placeholder: "銀行名を入力してください",
    },
    bankBranchName: {
      label: "支店名",
      placeholder: "支店名を入力してください",
    },
    accountNumber: {
      label: "口座番号",
      placeholder: "口座番号を入力してください",
    },
    accountName: {
      label: "口座名義",
      placeholder: "口座名義を入力してください",
    },
  },
  workInformation: {
    title: "業務情報",
    label: "支払通知書適応業務",
    addBtn: "追加",
    removeBtn: "削除",
  },
  contractInformation: {
    title: "契約情報",
    contractStatus: {
      label: "契約有効区分",
      valid: "あり",
      invalid: "なし",
    },
    contractStartDate: {
      label: "直近の契約締結日",
    },
    contractEndDate: {
      label: "直近の契約終了日",
    },
    currentContractFile: "直近の契約書類PDF",
    listContractFile: "logに応じた契約書類PDF",
  },
  memo: {
    title: "メモ",
    placeholder: "メモを入力してください",
  },
  uploadFileContract: {
    label: "直近の契約書類PDF",
    title: "ファイルをここにドラッグアンドドロップ",
    textBtn: "またはファイルを選択",
    error: {
      fileType: "添付可能なファイルは「pdf」となります。",
      fileSize: "添付ファイルのサイズは5MB以内にしてください。",
    },
  },
  modal: {
    createSuccess: "ワーカーを追加しました。",
    editSuccess: "ワーカーの情報を更新しました。",
    confirmDeleteWorker: "本当に削除してもよろしいですか？",
    deleteWorkerSuccess: "ワーカーを削除しました。",
    confirmDelete: "このタスクを削除しますか？\n「本確定」以外の実績データも削除される可能性があります。",
  },
}
